import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { iframeService } from '@pascal/pascal-core';
import { MainBetChip, PlayerCard, PlayerCardsPoint, SideBet } from '../index';
import { BET_TYPE, BET_TYPE_ODD } from '../../enums/actionTypes';
import { doBetStore } from '../../store/doBetStore';
import SideBetsWrapper from '../../containers/sideBetsWrapper';
import { winningAmountStore } from '../../store/winningAmountStore';
import { gameStore } from '../../store/gameStore';

const PlayerHand = observer(
  ({ boxInfo: { hands, boxIndex }, boxAmountByBetType = {}, sideBetsInfo = {} }) => {
    const { selectedChip, updateBetsModel, quickBets } = doBetStore;
    const { setLastWin } = winningAmountStore;
    const { isInsurance, isInsuranceLose, activeBox, isInsuranceDecisionOpened, isBetsClosed } =
      gameStore;
    const { userId } = userInfoStore;
    const { activeFreeBet } = freeBetStore;

    const handleDoChip = useCallback(
      (hand, betType) => {
        setLastWin(null);
        if (userId) {
          updateBetsModel({
            type: betType,
            boxIndex: hand,
            amount: selectedChip,
          });
        } else {
          iframeService.sendPgLogin();
        }
      },
      [selectedChip, updateBetsModel, userId, setLastWin]
    );

    return (
      <div
        className={`tb-player-seat ${
          !boxAmountByBetType[BET_TYPE.main]?.amount && !isBetsClosed ? '' : ''
        } ${
          boxIndex === activeBox || activeBox === null || isInsuranceDecisionOpened ? 'active' : ''
        } with-chip`}
      >
        <span className='tb-player-seat-circle' />
        {!isInsuranceLose && isInsurance && boxAmountByBetType[BET_TYPE.main] && (
          <span className='insurance_icon icon-boolean-yes' />
        )}

        <SideBetsWrapper>
          <SideBet
            activeFreeBet={activeFreeBet}
            boxIndex={boxIndex}
            quickBets={quickBets}
            handleDoChip={handleDoChip}
            sideBetType={BET_TYPE.side21plus3}
            boxAmountByBetType={boxAmountByBetType}
            sideBetPossibleWinOdd={sideBetsInfo[BET_TYPE_ODD.side21plus3Odd]}
            calculatedSideBets={sideBetsInfo.calculatedSideBets}
            side='left'
            innerContent='21+3'
            odd={doBetStore.sideBetsInfo ? doBetStore.sideBetsInfo[boxIndex]?.side21plus3Odd : 0}
            isBetsClosed={isBetsClosed}
          />
          <SideBet
            activeFreeBet={activeFreeBet}
            boxIndex={boxIndex}
            quickBets={quickBets}
            handleDoChip={handleDoChip}
            sideBetType={BET_TYPE.sidePerfectPair}
            boxAmountByBetType={boxAmountByBetType}
            sideBetPossibleWinOdd={sideBetsInfo[BET_TYPE_ODD.sidePerfectPairOdd]}
            calculatedSideBets={sideBetsInfo.calculatedSideBets}
            side='right'
            innerContent='perfect pairs'
            odd={
              doBetStore.sideBetsInfo ? doBetStore.sideBetsInfo[boxIndex]?.sidePerfectPairOdd : 0
            }
            isBetsClosed={isBetsClosed}
          />
        </SideBetsWrapper>
        <MainBetChip
          activeFreeBet={activeFreeBet}
          boxIndex={boxIndex}
          quickBets={quickBets}
          handleDoChip={handleDoChip}
          boxAmountByBetType={boxAmountByBetType}
        />
        {hands && hands.main && (
          <PlayerCardsPoint boxIndex={boxIndex} firsHand={hands.main} secondHand={hands.split} />
        )}
        <div className={`tb-player-cards ${hands?.split ? 'split-cards' : ''}`}>
          {hands?.split && <PlayerCard hand={hands?.split} boxIndex={boxIndex} isSplit />}
          <PlayerCard hand={hands?.main} boxIndex={boxIndex} />
        </div>
      </div>
    );
  }
);

export default PlayerHand;
